import { useMediaBreakpoints } from './use-media-breakpoint';
export function useResponsiveProp(prop) {
  var _ref2, _ref3;

  const [isMobile, isTablet, isDesktop] = useMediaBreakpoints();

  if (!Array.isArray(prop)) {
    return prop;
  }

  const [propMobile, propTablet, propDesktop, propWideScreen] = prop;

  if (isMobile) {
    return propMobile;
  }

  if (isTablet) {
    return propTablet !== null && propTablet !== void 0 ? propTablet : propMobile;
  }

  if (isDesktop) {
    var _ref;

    return (_ref = propDesktop !== null && propDesktop !== void 0 ? propDesktop : propTablet) !== null && _ref !== void 0 ? _ref : propMobile;
  }

  return (_ref2 = (_ref3 = propWideScreen !== null && propWideScreen !== void 0 ? propWideScreen : propDesktop) !== null && _ref3 !== void 0 ? _ref3 : propTablet) !== null && _ref2 !== void 0 ? _ref2 : propMobile;
}